import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};

const YoutubeIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.775 8.0562C23.775 8.0562 23.55 6.4062 22.8375 5.6562C21.9375 4.7187 20.8875 4.6812 20.4375 4.6437C17.025 4.4187 12 4.4187 12 4.4187C12 4.4187 6.975 4.4187 3.6 4.6437C3.1125 4.6812 2.1 4.7187 1.2 5.6562C0.4875 6.3687 0.2625 8.0562 0.2625 8.0562C0.2625 8.0562 0 10.0062 0 11.9562V13.7937C0 15.7437 0.225 17.6937 0.225 17.6937C0.225 17.6937 0.45 19.3437 1.1625 20.0937C2.0625 21.0312 3.2625 21.0312 3.825 21.1062C5.7375 21.2937 12 21.3312 12 21.3312C12 21.3312 17.025 21.3312 20.4 21.0687C20.8875 21.0312 21.9 20.9937 22.8 20.0562C23.5125 19.3437 23.7375 17.6562 23.7375 17.6562C23.7375 17.6562 24 15.7062 24 13.7562V11.9187C24 10.0062 23.775 8.0562 23.775 8.0562ZM9.525 15.9687V9.2187L16.0125 12.5937L9.525 15.9687Z"
      fill={color}
    />
  </svg>
);

export default YoutubeIcon;
